import { Data, Modal as ModalModule, Utils } from 'common';
import React from 'react';
import { isInTrialBillingPeriod } from '../subscriptionPlan/planRules';
import { RoutePath } from '../utils/RoutePath';

const { Modal, ModalButtonActionType } = ModalModule;
const { BillingPlans } = Utils;
const { PlanIds } = Data;

interface AddSeatsModalData {
	maxSeats: number;
	onNavigate?: (path: string, state?: unknown) => void;
}

interface AddSeatsModalProps {
	modalId: number;
	data: AddSeatsModalData;
}

const AddSeatsModal = ({ modalId, data }: AddSeatsModalProps) => {
	const { maxSeats, onNavigate } = data;

	const { planDetails } =
		((Utils.Session as any).getAccountInfo() as {
			planDetails?: { planId?: number };
		}) ?? {};
	const isTrialMode =
		planDetails?.planId === PlanIds.Trial401 && isInTrialBillingPeriod();

	const cancelButton = isTrialMode
		? undefined
		: {
				type: ModalButtonActionType.Cancel,
				text: 'Cancel',
				dataqa: 'add-seats-cancel-button',
			};

	const confirmButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Confirm',
		dataqa: 'add-seats-confirm-button',
		onClick: (closeModal: () => void) => {
			closeModal();
			if (onNavigate) {
				onNavigate(RoutePath.changePlan, { focusSeats: true });
			}
		},
	};

	return (
		<Modal
			modalId={modalId}
			header="Add Additional User Seats"
			className="account-users add-seats-modal"
			primaryButton={confirmButton}
			secondaryButton={cancelButton}
		>
			<div className="p-grid">
				{isTrialMode ? (
					<>
						<p className="p-col-12">
							You have access to {maxSeats} user{' '}
							{maxSeats === 1 ? 'seat' : 'seats'} during your trial. All user
							seats are currently being used.
						</p>
						<p className="p-col-12">
							Upgrade your subscription for access to more seats.
						</p>
					</>
				) : (
					<>
						<p className="p-col-12">
							You have access to {maxSeats} user{' '}
							{maxSeats === 1 ? 'seat' : 'seats'}. All user seats are currently
							being used.
						</p>
						<p className="p-col-12">
							Add additional seats, or upgrade your subscription for access to
							more seats. You can also delete users instead of adding new seats.
						</p>
					</>
				)}
			</div>
		</Modal>
	);
};

export default AddSeatsModal;
